import { Medicine, MedicineBatch, StockMovement } from '../../types'

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat('en-ZM', {
    style: 'currency',
    currency: 'ZMW',
    maximumFractionDigits: 2,
  }).format(amount)
}

export function isLowStock(medicine: Medicine) {
  return (
    medicine.currentQuantity > 0 &&
    medicine.currentQuantity <= medicine.reorderLevel
  )
}

export function isOutOfStock(medicine: Medicine) {
  return medicine.currentQuantity <= 0
}

export function isExpiringWithin(batch: MedicineBatch, days: number) {
  const today = startOfToday()
  const limit = new Date(today)
  limit.setDate(limit.getDate() + days)
  const expiry = new Date(`${batch.expiryDate}T23:59:59`)
  return expiry >= today && expiry <= limit && batch.quantity > 0
}

export function isExpired(batch: MedicineBatch) {
  return (
    new Date(`${batch.expiryDate}T23:59:59`) < startOfToday() &&
    batch.quantity > 0
  )
}

export function isToday(date: string) {
  return date.slice(0, 10) === new Date().toISOString().slice(0, 10)
}

export function movementLabel(movement: StockMovement) {
  return movement.type.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export function stockStatus(medicine: Medicine) {
  if (isOutOfStock(medicine)) return 'Out of stock'
  if (isLowStock(medicine)) return 'Low stock'
  return 'In stock'
}

function startOfToday() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}
